<template>
    <form v-if='!success' class='content'>
        <!-- <h1 class='title'>{{ schoolName }}</h1> -->
        <h3>会員登録</h3>
        <div class='field'>
            <label class='label'>学年・組・氏名</label>
            <div class='control has-icons-left'>
                <input class='input' type='text' placeholder='2年3組 見本太郎' v-model='name' required/>
                <span class='icon is-small is-left'>
                    <i class='fas fa-user'></i>
                </span>
            </div>
        </div>

        <div class='field'>
            <label class='label'>メールアドレス</label>
            <div class='control has-icons-left'>
                <input class='input' type='email' placeholder='example@windyfly.art' v-model='email' required/>
                <span class='icon is-small is-left'>
                    <i class='fas fa-envelope'></i>
                </span>
            </div>
        </div>

        <div class='field'>
            <label class='label'>パスワード</label>
            <div class='control has-icons-left'>
                <input class='input' type='password' placeholder='8文字以上256文字以内' minlength='8' maxlength='256' v-model='password' required/>
                <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                </span>
            </div>
        </div>

        <div class='field'>
            <label class='label'>電話番号</label>
            <div class='control has-icons-left'>
                <input class='input' type='tel' placeholder='ハイフンなし、半角のみ' pattern="\d{10,11}" v-model='phone' required/>
                <span class='icon is-small is-left'>
                    <i class='fas fa-phone'></i>
                </span>
            </div>
        </div>

        <!-- <div class='field'>
            <label class='label'>ログインID</label>
            <div class='control has-icons-left'>
                <input class='input' type='text' placeholder='20文字以内' v-model='loginId' maxlength='20' required/>
                <span class='icon is-small is-left'>
                    <i class='fas fa-id-card'></i>
                </span>
            </div>
        </div> -->

        <div class='field'>
            <label class='label'>郵便番号</label>
            <div class='control'>
                <input class='input' type='text' placeholder='ハイフンなし、半角のみ' pattern="\d{7,7}" v-model='postal' required/>
            </div>
        </div>

        <div class='field'>
            <label class='label'>住所</label>
            <div class='control'>
                <input class='input' type='text' v-model='address' required/>
            </div>
        </div>

        <button type='button' class='button is-primary is-medium register' @click='register'>登録</button>
  </form>
  <div v-else class='success'>
      <h1 class='title'>{{ schoolName }}</h1>
      <h2 class='sub-title'>ご登録メールアドレス宛に認証用メールを送信しました</h2>
  </div>
</template>

<script>
export default {
    name: 'RegisterPage',
    components: {},
    data () {
        return {
            name: '',
            email: '',
            password: '',
            address: '',
            postal: '',
            phone: '',
            // loginId: '',
            success: false,
            schoolName: ''
        }
    },
    methods: {
        register () {
            const self = this

            if (document.getElementsByTagName('form')[0].reportValidity()) {
                self.axios.post(`${process.env.API_URL}/register`, {
                    name: self.name,
                    email: self.email,
                    password: self.password,
                    address: self.address,
                    postal: self.postal,
                    phone: self.phone
                    // login_id: self.loginId
                }).then((res) => {
                    if (res.data.message === 'OK') {
                        self.success = true
                    } else if (res.data.message === 'loginId duplicated') {
                        self.$root.$emit('notification', 'is-danger', '入力されたログインIDは既に使用されています')
                    } else if (res.data.message === 'email duplicated') {
                        self.$root.$emit('notification', 'is-danger', '入力されたメールアドレスは既に使用されています')
                    }
                }).catch(e => {
                    alert('サーバーに問題が発生しています。')
                })
            }
        }
    },
    created () {
        // const self = this

        // self.axios.get(`${process.env.API_URL}/school`, {
        //     name: self.name,
        //     email: self.email,
        //     password: self.password,
        //     address: self.address,
        //     login_id: loginId
        // }).then((res) => {
        //     self.success = true
        // }).catch(e => {
        //     alert('サーバーに問題が発生しています。')
        // })
    }
}
</script>

<style scoped>
.login {
  margin-top: 30px;
  width: 100%;
}

.content {
    max-width: 640px;
    padding: 20px;
    margin: auto;
    margin-top: 50px;
}

.register {
    width: 100%;
    margin-top: 30px;
}

.title {
    text-align: center;
    margin-bottom: 50px;
}

.sub-title {
    text-align: center;
    font-size: 1.5em;
}

.success {
    margin-top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/routes/RegisterPage.vue